import styled from "styled-components";
import { inputBorderColor, newsecondaryColor, mediumFont } from "@app/styles";

type Props = {
  active?: boolean;
  notValid?: boolean;
  isValid?: boolean;
};

export const AccordianContainer = styled.div`
  width: 100%;
`;
export const AccordianItemBox = styled.div`
  min-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  background: #ffffff;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1); */
  border: 1px solid ${inputBorderColor};
  border-radius: 8px;
  margin: 0 0 16px 0;
  padding: 0 16px;
  ${({ notValid }: Props) => {
    if (notValid) {
      return `  background-color: #FEF7FA;
                  border-color: #D63763;`;
    }
  }}
  ${({ isValid }: Props) => {
    if (isValid) {
      return ` background-color: #f7f8f9;
            border-color: ${newsecondaryColor};`;
    }
  }}
`;
export const AccordianBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${({ active }: Props) => {
    if (active) {
      return ` padding: 16px 0`;
    }
  }}
`;
export const AccordianTitleBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;
export const Title = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  ${mediumFont};
  line-height: 1.5;
  color: ${newsecondaryColor};
`;

export const DeleteBox = styled.div`
  /* margin-right: 24px; */
`;

export const ArrowBox = styled.div`
  /* margin-top: 3px; */
  width: 16px;
  height: 16px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 16px;
    height: 16px;
  }
`;
